import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "row g-3" }
const _hoisted_5 = { class: "col-lg-2" }
const _hoisted_6 = { class: "col-lg-2" }
const _hoisted_7 = { class: "col-lg-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-lg-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-lg-2" }
const _hoisted_14 = { class: "row g-3" }
const _hoisted_15 = { class: "col-lg-2" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = { class: "col-lg-1" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { class: "col-lg-1" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "col-lg-2" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "col-lg-2" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "col-lg-2" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { class: "col-lg-1" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "col-lg-1" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "row mb-3" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "row mb-3" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 0,
  class: "form-group"
}
const _hoisted_47 = ["onUpdate:modelValue", "disabled"]
const _hoisted_48 = {
  key: 1,
  class: "form-group"
}
const _hoisted_49 = ["onUpdate:modelValue", "disabled"]
const _hoisted_50 = {
  key: 2,
  class: "form-group"
}
const _hoisted_51 = ["onUpdate:modelValue", "disabled"]
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = { class: "row mb-3" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = {
  key: 0,
  class: "form-group"
}
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = {
  key: 1,
  class: "form-group"
}
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = {
  key: 0,
  class: "form-group"
}
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = {
  key: 1,
  class: "form-group"
}
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = { class: "row mb-3" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = { class: "col-md-4" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = { class: "col-md-4" }
const _hoisted_78 = { class: "form-group" }
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = { class: "col-lg-12 toggle-row" }
const _hoisted_84 = { class: "toggle-container" }
const _hoisted_85 = { class: "toggle-switch" }
const _hoisted_86 = { class: "toggle-container" }
const _hoisted_87 = { class: "toggle-switch" }
const _hoisted_88 = { class: "toggle-container" }
const _hoisted_89 = { class: "toggle-switch" }
const _hoisted_90 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3" }, [
          _createElementVNode("h3", { class: "mb-0" }, "Вакансия")
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.temp.title) = $event)),
                class: "form-control",
                placeholder: "Название"
              }, null, 512), [
                [_vModelText, _ctx.temp.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.temp.number) = $event)),
                class: "form-control",
                placeholder: "Номер"
              }, null, 512), [
                [_vModelText, _ctx.temp.number]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.temp.managerId) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateMainCoordinators && _ctx.updateMainCoordinators(...args))),
                class: "form-control"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managers, (manager) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: manager.id,
                    value: manager.id
                  }, _toDisplayString(manager.name), 9, _hoisted_8))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.temp.managerId]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.temp.mainCoordinatorId) = $event)),
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateCoordinators && _ctx.updateCoordinators(...args))),
                class: "form-control"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.main_coordinators.filter(mc => mc && mc.owner_id === _ctx.temp.managerId), (main_coordinator) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: main_coordinator.id,
                    value: main_coordinator.id
                  }, _toDisplayString(main_coordinator.name), 9, _hoisted_10))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.temp.mainCoordinatorId]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.temp.coordinatorId) = $event)),
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setCoordinatorPhone && _ctx.setCoordinatorPhone(...args))),
                class: "form-control"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coordinators.filter(c =>  c &&
                    (c.owner_id === _ctx.temp.mainCoordinatorId || (_ctx.dialogStatus === 'update' && !_ctx.temp.mainCoordinatorId && !_ctx.temp.managerId))), (coordinator) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: coordinator.id,
                    value: coordinator.id
                  }, _toDisplayString(coordinator.name), 9, _hoisted_12))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.temp.coordinatorId]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.temp.coordinatorPhone) = $event)),
                class: "form-control",
                placeholder: "Тел. коорд."
              }, null, 512), [
                [_vModelText, _ctx.temp.coordinatorPhone]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
            _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "mb-1" }, "Кандидат", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.temp.candidates, (candidate, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "mb-3"
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((candidate.position) = $event),
                      class: "form-control",
                      placeholder: "Должность"
                    }, null, 8, _hoisted_16), [
                      [_vModelText, candidate.position]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((candidate.rate) = $event),
                      class: "form-control",
                      placeholder: "Ставка"
                    }, null, 8, _hoisted_18), [
                      [_vModelText, candidate.rate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": ($event: any) => ((candidate.rateFrequency) = $event),
                      class: "form-control"
                    }, _cache[16] || (_cache[16] = [
                      _createElementVNode("option", { value: "1" }, "в час", -1),
                      _createElementVNode("option", { value: "2" }, "в день", -1),
                      _createElementVNode("option", { value: "3" }, "в месяц", -1)
                    ]), 8, _hoisted_20), [
                      [_vModelSelect, candidate.rateFrequency]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((candidate.quantity1) = $event),
                      class: "form-control",
                      placeholder: "Мужчин"
                    }, null, 8, _hoisted_22), [
                      [_vModelText, candidate.quantity1]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((candidate.quantity2) = $event),
                      class: "form-control",
                      placeholder: "Женщин"
                    }, null, 8, _hoisted_24), [
                      [_vModelText, candidate.quantity2]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": ($event: any) => ((candidate.quantity3) = $event),
                      class: "form-control",
                      placeholder: "Пар"
                    }, null, 8, _hoisted_26), [
                      [_vModelText, candidate.quantity3]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((candidate.age) = $event),
                      class: "form-control",
                      placeholder: "Возраст"
                    }, null, 8, _hoisted_28), [
                      [_vModelText, candidate.age]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_el_select, {
                      modelValue: candidate.nation,
                      "onUpdate:modelValue": ($event: any) => ((candidate.nation) = $event),
                      multiple: "",
                      placeholder: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nations, (nation) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: nation,
                            label: nation,
                            value: nation
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addCandidateRow && _ctx.addCandidateRow(...args)))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block" }),
                _createElementVNode("span")
              ], -1)
            ])),
            _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
            _cache[21] || (_cache[21] = _createTextVNode()),
            _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.temp.candidates, (candidate, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "candidate-row border rounded p-3 mb-4"
            }, [
              _createElementVNode("h3", null, [
                _cache[23] || (_cache[23] = _createTextVNode(" Описание ")),
                (candidate.position)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                      _createTextVNode(" (" + _toDisplayString(candidate.position) + ") ", 1),
                      (candidate.isActive === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "(неактивна)"))
                        : _createCommentVNode("", true),
                      (candidate.isActive === 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-warning btn-sm mx-1",
                            title: "Деактивировать должность",
                            onClick: ($event: any) => (_ctx.setCandidateStatus(candidate, 0))
                          }, " Деактивировать ", 8, _hoisted_32))
                        : _createCommentVNode("", true),
                      (candidate.isActive === 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "btn btn-success btn-sm mx-1",
                            title: "Активировать должность",
                            onClick: ($event: any) => (_ctx.setCandidateStatus(candidate, 1))
                          }, " Активировать ", 8, _hoisted_33))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn btn-danger btn-sm mx-1",
                        title: "Удалить должность",
                        onClick: ($event: any) => (_ctx.deleteCandidateRow(candidate))
                      }, " Удалить должность ", 8, _hoisted_34)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.city) = $event),
                      placeholder: "Город"
                    }, null, 8, _hoisted_38), [
                      [_vModelText, candidate.city]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.address) = $event),
                      placeholder: "Адрес"
                    }, null, 8, _hoisted_41), [
                      [_vModelText, candidate.address]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.workShift) = $event)
                    }, _cache[24] || (_cache[24] = [
                      _createElementVNode("option", { value: 1 }, "Одна смена", -1),
                      _createElementVNode("option", { value: 2 }, "Две смены", -1),
                      _createElementVNode("option", { value: 3 }, "Три смены", -1)
                    ]), 8, _hoisted_45), [
                      [_vModelSelect, candidate.workShift]
                    ])
                  ]),
                  (candidate.workShift)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((candidate.schedule1) = $event),
                          disabled: !candidate.workShift,
                          placeholder: "график смена 1"
                        }, null, 8, _hoisted_47), [
                          [_vModelText, candidate.schedule1]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (candidate.workShift && (candidate.workShift === 2 || candidate.workShift === 3))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((candidate.schedule2) = $event),
                          disabled: !candidate.workShift || candidate.workShift === 1,
                          placeholder: "график смена 2"
                        }, null, 8, _hoisted_49), [
                          [_vModelText, candidate.schedule2]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (candidate.workShift && candidate.workShift === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((candidate.schedule3) = $event),
                          disabled: !candidate.workShift || candidate.workShift === 1 || candidate.workShift === 2,
                          placeholder: "график смена 3"
                        }, null, 8, _hoisted_51), [
                          [_vModelText, candidate.schedule3]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.workShiftType) = $event)
                    }, _cache[28] || (_cache[28] = [
                      _createElementVNode("option", { value: 1 }, "Дневные", -1),
                      _createElementVNode("option", { value: 2 }, "Ночные", -1),
                      _createElementVNode("option", { value: 3 }, "Смешанные", -1)
                    ]), 8, _hoisted_54), [
                      [_vModelSelect, candidate.workShiftType]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.livingExists) = $event)
                    }, _cache[29] || (_cache[29] = [
                      _createElementVNode("option", { value: 0 }, "Жилья нет", -1),
                      _createElementVNode("option", { value: 1 }, "Жильё есть", -1)
                    ]), 8, _hoisted_58), [
                      [_vModelSelect, candidate.livingExists]
                    ])
                  ]),
                  (candidate.livingExists === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((candidate.livingType) = $event)
                        }, _cache[30] || (_cache[30] = [
                          _createElementVNode("option", { value: 1 }, "Пара отдельно", -1),
                          _createElementVNode("option", { value: 2 }, "По две пары", -1),
                          _createElementVNode("option", { value: 3 }, "Нет мест", -1)
                        ]), 8, _hoisted_60), [
                          [_vModelSelect, candidate.livingType]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (candidate.livingExists === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((candidate.livingPrice) = $event),
                          placeholder: "цена жилья"
                        }, null, 8, _hoisted_62), [
                          [_vModelText, candidate.livingPrice]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.isArrival) = $event)
                    }, _cache[33] || (_cache[33] = [
                      _createElementVNode("option", { value: 0 }, "Доезда нет", -1),
                      _createElementVNode("option", { value: 1 }, "Доезд есть", -1)
                    ]), 8, _hoisted_65), [
                      [_vModelSelect, candidate.isArrival]
                    ])
                  ]),
                  (candidate.isArrival === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((candidate.arrivalAddress) = $event),
                          placeholder: "адрес"
                        }, null, 8, _hoisted_67), [
                          [_vModelText, candidate.arrivalAddress]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (candidate.isArrival === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((candidate.arrivalPrice) = $event),
                          placeholder: "цена"
                        }, null, 8, _hoisted_69), [
                          [_vModelText, candidate.arrivalPrice]
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.livingPlaces1) = $event),
                      placeholder: "Мужчин"
                    }, null, 8, _hoisted_73), [
                      [_vModelText, candidate.livingPlaces1]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.livingPlaces2) = $event),
                      placeholder: "Женщин"
                    }, null, 8, _hoisted_76), [
                      [_vModelText, candidate.livingPlaces2]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((candidate.livingPlaces3) = $event),
                      placeholder: "Пар"
                    }, null, 8, _hoisted_79), [
                      [_vModelText, candidate.livingPlaces3]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control description",
                  "onUpdate:modelValue": ($event: any) => ((candidate.description) = $event),
                  rows: "10",
                  cols: "10",
                  placeholder: `Описание ${candidate.position}`
                }, "                      ", 8, _hoisted_81), [
                  [_vModelText, candidate.description]
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_82, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control description",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.temp.comment) = $event)),
              rows: "10",
              cols: "10",
              placeholder: "Комментарий"
            }, null, 512), [
              [_vModelText, _ctx.temp.comment]
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "toggle-label" }, "Активная", -1)),
              _createElementVNode("label", _hoisted_85, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "toggle-input",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.temp.isActive) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.temp.isActive]
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "toggle-slider" }, null, -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "toggle-label" }, "Приоритет", -1)),
              _createElementVNode("label", _hoisted_87, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "toggle-input",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.temp.isPriority) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.temp.isPriority]
                ]),
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "toggle-slider" }, null, -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "toggle-label" }, "Для посредников", -1)),
              _createElementVNode("label", _hoisted_89, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "toggle-input",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.temp.isMediator) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.temp.isMediator]
                ]),
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "toggle-slider" }, null, -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _cache[43] || (_cache[43] = _createElementVNode("a", {
              href: "/vacancies/status1",
              class: "btn btn-danger me-3"
            }, "Отменить", -1)),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isEditPage ? _ctx.updateData() : _ctx.createData()))
            }, _cache[42] || (_cache[42] = [
              _createElementVNode("i", { class: "bi bi-plus" }, null, -1),
              _createTextVNode(" Сохранить ")
            ]))
          ])
        ], 32)
      ])
    ])
  ]))
}